<template>
    <div class="overlay-recipe-dialog" :class="bemFacets">
        <h1 class="u-reset u-reset__sty">
            {{ title }}
        </h1>

        <br><br>

        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="description"/>

        <br><br>

        <button type="button"
                class="btn btn__medium btn__primary"
                v-if="onAccept"
                @click="onAccept">
            accept
        </button>

        <button type="button"
                class="btn btn__medium btn__primary"
                v-if="onDecline"
                @click="onDecline">
            decline
        </button>

        <br><br>

        <pre v-text="$attrs"/>
    </div>
</template>

<script>
    import { noop } from 'lodash';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [
            bemMixin('overlay-recipe-dialog'),
        ],
        props: {
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: true,
            },
            onAccept: {
                type: Function,
                default: () => noop,
            },
            onDecline: {
                type: Function,
                default: () => noop,
            },
        },
    };
</script>
